










































import { Component, Vue, Prop } from "vue-property-decorator";
import Popper from "popper.js";

const roundPopperPosition = (data: Popper.Data): Popper.Data => {
  data.offsets.popper.top = Math.round(data.offsets.popper.top);
  data.offsets.popper.left = Math.round(data.offsets.popper.left);
  return data;
};

@Component({})
class BSettingDd extends Vue {
  @Prop({ type: Boolean, default: true }) translate!: boolean;
  @Prop({ type: Boolean, default: true }) edit!: boolean;
  @Prop({ type: Boolean, default: true }) deleted!: boolean;
  @Prop({ type: Boolean, default: true }) restore!: boolean;
  @Prop({ type: Boolean, default: true }) open!: boolean;
  @Prop({ type: Boolean, default: false }) forceDelete!: boolean;

  popperOpts = {
    positionFixed: true,
    modifiers: {
      roundPosition: {
        enabled: true,
        order: 840,
        fn: roundPopperPosition,
      },
    },
  };
}
export default BSettingDd;
